/*
 * Copyright (c) 2026 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useEffect } from 'react'

import { contactMethodOf } from '@/lib/analytics/contact-links'
import { trackEvent } from '@/lib/analytics/google'
import { trackVercelEvent } from '@/lib/analytics/vercel'

/**
 * Counts clicks on email, phone, WhatsApp and Microsoft Bookings links in GA4 and Vercel Analytics. A click shows
 * intent only: the visitor may never send a message, make a call or complete a booking. Mounted once in the shared
 * layout, so it covers links from every component and CMS block. Listens in the capture phase, so a link that stops
 * the click from bubbling is still counted.
 */
export const ContactLinkTracking = () => {
  useEffect(() => {
    /**
     * Tracks a click when it lands on a contact link.
     *
     * @param event - the click
     */
    const handleClick = (event: MouseEvent) => {
      const method = contactMethodOf(event.target)

      if (!method) {
        return
      }

      trackEvent('contact_click', { contact_method: method })
      trackVercelEvent('contact_click', { method })
    }

    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [])

  return null
}
